

















import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
@Component
export default class ConfigPopup extends Vue {
    @Prop() title!: string;
    @Prop() text!: string;
    @Prop() videoWebm!: string;
    @Prop() videoMp4!: string;
    @Prop() videoWebmType!: string;
    @Prop() videoMp4Type!: string;
    @Prop() url!: string;
    private show: boolean = false;
    constructor() {
        super();
    }
    private close() {
        this.$emit('close');
    }
    private modifyIframe(e: Event) {
        const iframe = e.target as HTMLIFrameElement;
        const iframe_doc = iframe.contentWindow ? iframe.contentWindow.document : iframe.contentDocument;
        if (iframe_doc) {
            const body = iframe_doc.querySelector('#body');
            if (body) {
                body.classList.add('page-in-iframe-modal');
                this.show = true;
            }
        }
    }
}
